<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando dados...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>


    <div class="form-edit-page">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ objEdicao.cdestabelecimento }}</div>
            </div>
            <div class="form-item-char10">
                <label class="label-caption" for="nrosim">Nro SIM</label>
                <input type="text" class="input-center" v-model="objEdicao.nrosim" id="nrosim" maxlength="9" />
            </div>
            <div class="form-item">
                <label class="label-caption" for="nmestabelecimento">Nome do Estabelecimento</label>
                <input type="text" v-model="objEdicao.nmestabelecimento" id="nmestabelecimento" required maxlength="80" v-uppercase />
            </div>
            <div class="form-item">
                <label class="label-caption" for="nmfantasia">Nome Fantasia</label>
                <input type="text" v-model="objEdicao.nmfantasia" id="nmfantasia" maxlength="80" v-uppercase />
            </div>
            <div class="form-item-char20">
                <label class="label-caption" for="cpfcnpj">CPF/CNPJ</label>
                <input type="text" class="input-center" v-model="objEdicao.cpfcnpj" id="cpfcnpj" maxlength="18" v-mask-cpf-cnpj />
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption" for="endereco">Endereço</label>
                <input type="text" v-model="objEdicao.endereco" id="endereco" maxlength="80" v-uppercase />
            </div>
            <div class="form-item-char10">
                <label class="label-caption" for="nmendereco">Número</label>
                <input type="text" class="input-right" v-model="edNmEndereco" id="nmendereco" v-number maxlength="8" />
            </div>  
            <div class="form-item">
                <label class="label-caption" for="complemento">Complemento</label>
                <input type="text" v-model="objEdicao.complemento" id="complemento" maxlength="80" v-uppercase />
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption" for="bairro">Bairro</label>
                <input type="text" v-model="objEdicao.bairro" id="bairro" maxlength="60" v-uppercase />
            </div>
            <div class="form-item-char10">
                <label class="label-caption" for="cep">CEP</label>
                <input type="text" v-model="objEdicao.cep" id="cep" v-cep maxlength="10" />
            </div>
            <div class="form-item-telefone">
                <label class="label-caption" for="fone">Telefone</label>
                <input type="text" v-model="objEdicao.fone" id="fone" v-phone maxlength="15" />
            </div>
            <div class="form-item-telefone">
                <label class="label-caption" for="fone2">Telefone II</label>
                <input type="text" v-model="objEdicao.fone2" id="fone2" v-phone maxlength="15" />
            </div>
            <div class="form-item-char20">
                <label class="label-caption" for="ie">Inscrição Estadual</label>
                <input type="text" class="input-center" v-model="objEdicao.ie" id="ie" maxlength="18" />
            </div>
            <div class="form-item-char20">
                <label class="label-caption" for="im">Inscrição Municipal</label>
                <input type="text" class="input-center" v-model="objEdicao.im" id="im" maxlength="18" />
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Nome do Proprietário</label>
                <input type="text" v-model="objEdicao.prop_nome" maxlength="100" v-uppercase />
            </div>
            
            <div class="form-item-char15">
                <label class="label-caption">CPF</label>
                <input type="text" class="input-center" v-model="objEdicao.prop_cpf" v-cpf maxlength="14" />
            </div>

            <div class="form-item-telefone">
                <label class="label-caption">Nro Contato</label>
                <input type="text" v-model="objEdicao.prop_fone" v-phone maxlength="15" />
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption" for="nmcontato">Nome Contato</label>
                <input type="text" v-model="objEdicao.nmcontato" id="nmcontato" />
            </div>
            <div class="form-item-telefone">
                <label class="label-caption" for="celularcontato">Celular Contato</label>
                <input type="text" v-model="objEdicao.celular_contato" id="celularcontato" v-phone maxlength="15" />
            </div>
            <div class="form-item">
                <label class="label-caption" for="emailcontato">Email Contato</label>
                <input type="email" v-model="objEdicao.email_contato" id="emailcontato" />
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption" for="email">Email</label>
                <input type="email" v-model="objEdicao.email" id="email" />
            </div>
            <div class="form-item">
                <label class="label-caption" for="email2">Email Alternativo</label>
                <input type="email" v-model="objEdicao.email2" id="email2" />
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption" for="obs">Observações</label>
                <input type="text" v-model="objEdicao.obs" id="obs" />
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item-char20">
                <AreaComercioSelect class="form-item" v-model:opcaoSelecionada="objEdicao.cdareacomercio" />
            </div>
             <div class="form-item-char20">
                <StSisbiSelect class="form-item" v-model:opcaoSelecionada="objEdicao.cdstsisbi" />
            </div>
             <div class="form-item-char20">
                <EpRdSelect class="form-item" v-model:idSelecionado="objEdicao.ideprd" />
            </div>
            <AtividadeSelect class="form-item" v-model:atividadeSelecionada="objEdicao.idatividade" />
        </div>


        <div class="row row-space">
            <RTSelect class="form-item" v-model:idSelecionado="objEdicao.idrt" />
            <div class="form-item-coordenadas">
                <CoordenadasSelect v-model:modelValueLatitude="edLatitude" v-model:modelValueLongitude="edLongitude" />
            </div>
        </div>
        
        
        <div v-if="showSimSelect" class="row row-space">
            <SimSelect v-model:idSelecionado="idSim" />
        </div>
        
        <div class="row-end">
            <label for="ativo">Ativo</label>
            <input type="checkbox" class="input-checkbox" id="ativo" v-model="ckAtivo" />
        </div>

        <div class="row-end">
            <label for="cadsebraetec">Cadastrado no Sebraetec</label>
            <input type="checkbox" class="input-checkbox" id="cadsebraetec" v-model="ckCadSebraeTec" />
        </div>

        <div class="row-end">
            <label for="ckdadosmoveis">Dados móveis disponível</label>
            <input type="checkbox" class="input-checkbox" id="ckdadosmoveis" v-model="ckDadosMoveis" />
        </div>

        <div class="row-end">
            <label for="ckimpressora">Impressora disponível</label>
            <input type="checkbox" class="input-checkbox" id="ckimpressora" v-model="ckImpressora" />
        </div>

        <div class="row-end row-space">
            <label for="ckinternet">Internet disponível no local</label>
            <input type="checkbox" class="input-checkbox" id="ckinternet" v-model="ckInternet" />
        </div>

        <div class="row-end">
            <button type="button" class="btn-confirm" @click="salvarDados">Salvar</button>
            <button type="button" class="btn-cancel" @click="cancelForm">Cancelar</button>
        </div>
    </div>
</template>
  
<script setup>
import { criarEstabelecimento } from '@/models/estabelecimento';
import { onMounted, ref } from 'vue';
import { formatInteger, integerFromString } from '@/funcoes/utils';
import { genericPut, getCadastroById } from '@/funcoes/api';
import { globalStore } from '@/globals';
import AreaComercioSelect from '@/selects/estaticos/AreaComercioSelect.vue';
import AtividadeSelect from '@/components/selects/AtividadeSelect.vue';
import CoordenadasSelect from '@/components/CoordenadasSelect.vue';
import EpRdSelect from '@/selects/EpRdSelect.vue';
import RTSelect from '@/components/selects/RTSelect.vue';
import SimSelect from '@/components/selects/SimSelect.vue';
import StSisbiSelect from '@/selects/estaticos/StSisbiSelect.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({idEdicao: {type: Number, default: 0}});

const ckAtivo=ref(false);
const ckCadSebraeTec=ref(false);
const ckDadosMoveis=ref(false);
const ckImpressora=ref(false);
const ckInternet=ref(false);
const edNmEndereco=ref(null);
const edLatitude = ref(0);
const edLongitude = ref(0);
const idSim = ref(null);
const showSimSelect = ref(false);

const isLoading = ref(false);
const msgAlerta=ref(null);
const objEdicao = ref(criarEstabelecimento());


const cancelForm = () => {emit('close');}


const lerDados = async() => {
    try{
        isLoading.value = true;
        msgAlerta.value = null;
        if (props.idEdicao > 0) {
            try{
                const req = await getCadastroById('estabelecimento', props.idEdicao);
                Object.assign(objEdicao.value, req[0]);
            }catch (error){msgAlerta.value = error}
        }else{
            objEdicao.value.idep        = globalStore.idep;
            objEdicao.value.idsim       = globalStore.idsim;
            showSimSelect.value         = (globalStore.idsim==0);
        }
        objEdicao.value.idlogin         = globalStore.idlogin;
        ckAtivo.value                   = objEdicao.value.ativo === 'S';
        ckCadSebraeTec.value            = objEdicao.value.cad_sebraetec === 'S';
        ckDadosMoveis.value             = objEdicao.value.ckdados_moveis === 'S';
        ckImpressora.value              = objEdicao.value.ckimpressora === 'S';
        ckInternet.value                = objEdicao.value.ckinternet === 'S';
        edNmEndereco.value              = formatInteger(objEdicao.value.nmendereco);
        edLatitude.value                = objEdicao.value.latitude;
        edLongitude.value               = objEdicao.value.longitude;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value=false;}
}


const salvarDados = async () => {
    try {
        msgAlerta.value                 = null;
        if (!objEdicao.value.nmestabelecimento) throw new Error('Informe nome do estabelecimento');
        if (showSimSelect.value && !idSim.value) throw new Error('Informe SIM ao qual o estabelecimento pertence');
        isLoading.value                 = true;

        if (showSimSelect.value)
            objEdicao.value.idsim       = idSim.value;
        objEdicao.value.nmendereco      = integerFromString(edNmEndereco.value);  
        objEdicao.value.ativo           = ckAtivo.value ? 'S' : 'N';
        objEdicao.value.cad_sebraetec   = ckCadSebraeTec.value ? 'S' : 'N';
        objEdicao.value.ckdados_moveis  = ckDadosMoveis.value ? 'S' : 'N';
        objEdicao.value.ckimpressora    = ckImpressora.value ? 'S' : 'N';
        objEdicao.value.ckinternet      = ckInternet.value ? 'S' : 'N';
        objEdicao.value.latitude        = !edLatitude.value ? 0 : parseFloat(edLatitude.value.toString().replace(',', '.')) || 0;
        objEdicao.value.longitude       = !edLongitude.value ? 0 : parseFloat(edLongitude.value.toString().replace(',', '.')) || 0;
        const response                  = await genericPut('/cad/estabelecimento', objEdicao.value);
        if (response.bolok === 1){
            emit('save');
            emit('close');
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally{isLoading.value=false;}
}


onMounted(lerDados);
</script>